<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20" v-loading="loading">
    <div class="w100 cl-f">
      <span class="font-16">基本属性</span>
      <span class="fr blue font-14 cu-p" @click="backPage">返回列表</span>
    </div>

    <div class="w100 mt20" v-if="editServeData">
      <el-form class="w50" ref="form" :model="editServeData" label-width="80px" size="mini" v-show="!showEdit">
        <el-form-item label="服务名称">
          <p class="font-14">{{ editServeData.serveName }}</p>
        </el-form-item>
        <el-form-item label="服务主题">
          <el-select v-model="editServeData.serveTitleId" v-if="serveList.length">
            <el-option v-for="(item, index) in serveList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务部门">
          <el-select v-model="editServeData.deptServeId" v-if="deptList.length">
            <el-option v-for="(item, index) in deptList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="服务时限">
          <el-input-number v-model="editServeData.dueTimes" :min="1" placeholder="必填"></el-input-number>
          <span class="ml10">日</span>
        </el-form-item>
        <el-form-item label="服务人群">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="editServeData.serviceCrowd"></el-input>
        </el-form-item>
        <el-form-item label="服务说明">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="editServeData.serveIntro"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button plain @click="returnData">重置</el-button>
          <el-button type="primary" @click="updata" :disabled="!editServeData.dueTimes">确认修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EditView",
  props: [],
  data() {
    return {

      loading: false,
      serveList: [],
      deptList: [],

      showEdit: false,
      serveData: null,
      editServeData: null
    };
  },
  computed: {
    ...mapState(["userToken"])
  },
  mounted() {
    this.fetchServeList();
    this.fetchDeptList();
    this.fetchAppData();
  },
  methods: {
    fetchServeList() {
      this.GCD++;
      this.$http
        .post("option/query/serveTitle")
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == "0") {
            this.serveList = data.resData.data.filter((val, index) => index);
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.GCD--;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.GCD--;
        });
    },
    fetchDeptList() {
      this.GCD++;
      this.$http
        .post("option/query/serveDept")
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.deptList = data.resData.data.filter((val, index) => index);
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.GCD--;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.GCD--;
        });
    },
    fetchAppData() {
      this.GCD++;
      this.$http
        .get(`serve/getDetailById?id=${this.$route.params.id}`)
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.serveData = { ...data.resData };
            this.editServeData = { ...data.resData };
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.GCD--;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.GCD--;
        });
    },
    updata() {
      this.GCD++;
      this.$http
        .post(
          `serve/editServeDetail`,
          this.$qs.stringify({
            id: this.$route.params.id,
            serveTitleId: this.editServeData.serveTitleId,
            deptId: this.editServeData.deptServeId,
            deptName: this.findDeptName(),
            dueTimes: this.editServeData.dueTimes,
            serviceCrowd: this.editServeData.serviceCrowd,
            serveIntro: this.editServeData.serveIntro
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.$message({
              message: data.resMsg,
              type: "success"
            });
            this.serveData = { ...this.editServeData };
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.GCD--;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.GCD--;
        });
    },
    findDeptName() {
      for (const item of this.deptList) {
        if (item.value == this.editServeData.deptServeId) {
          return item.label;
        }
      }
    },
    backPage() {
      this.$router.go(-1);
    },
    returnData() {
      this.editServeData = {
        ...this.serveData
      };
    }
  },
  watch: {
    GCD(value, oldValue) {
      if (!value && oldValue) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    }
  }
};
</script>

<style scoped>
</style>
